module.exports = __webpack_public_path__ + "prod/20251205101532/img/logo_200.6488dd39.png";